import React from 'react';
import { v1 as uuid } from 'uuid';
import { get } from 'lodash';
import { connect } from 'react-redux';
import { compose } from 'redux';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { Checkbox } from '@fiverr-private/fit';
import { EventBus } from '@fiverr-private/futile/lib/event/EventBus';
import { secToTimestamp, collaborationEventBus } from '../../../Utils';
import { VIDEO_TYPE, AUDIO_TYPE, OVERLAY_CLICK_EVENT } from '../../../MediaViewer/consts';
import FilerrShape from '../../PropsShape/FilerrShape';
import Avatar from '../Avatar';
import { sendMixPanelEvent } from '../../../Utils/mixpanel';
import { START_NEW_COMMENT, START_NEW_REPLY, CLICKED_TIMESTAMP_TOGGLE, SAVE_NEW_COMMENT, SAVE_NEW_REPLY } from '../../../Utils/mixpanel/mixpanelEvents';
import reportToBigQuery from '../../../Utils/bigQueryReporter';
import { COLLABORATION_ACTIVE_STATUS } from '../../stateManager/collaborations/types';
import * as CommentsActions from '../../actions/comments';
import { getTempAnnotations } from '../../stateManager/tempAnnotations/selectors';
import * as LoadingsSelectors from '../../selectors/loading';
import * as CurrentsActions from '../../actions/current';
import * as CurrentsSelectors from '../../selectors/current';
import * as FilesSelectors from '../../selectors/files';
import * as FilerrsSelectors from '../../selectors/filerrs';
import * as CollaboratorsSelectors from '../../selectors/collaborators';
import * as Translations from '../../providers/i18n';
import { emitCommentBoxGotFocus, commentBoxCancelled, commentBoxOpened } from './actions';

import './style.scss';

export const commentBoxEventsBus = new EventBus();
export const COMMENT_BOX_FOCUS_EVENT = 'comment-box:focused';
export const COMMENT_BOX_EVENT_NAME = 'comment-box';

class CommentBox extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            isOpen: this.props.defaultOpen,
            checkBox: true,
            require: false,
            text: ''
        };

        this.open = this.open.bind(this);
        this.close = this.close.bind(this);
        this.save = this.save.bind(this);
        this.showTimeCode = this.showTimeCode.bind(this);
        this.onChange= this.onChange.bind(this);
        this.textareaChange = this.textareaChange.bind(this);
        this.onBoxClick = this.onBoxClick.bind(this);
    }

    componentDidMount() {
        const { body } = this.props;

        if (this.props.parentId){
            this.textarea.focus();
        }

        if (body) {
            // eslint-disable-next-line react/no-did-mount-set-state
            this.setState({
                text: body
            });
        }

        collaborationEventBus.on(OVERLAY_CLICK_EVENT, this.open);
    }

    componentDidUpdate(prevProps, prevState) {
        const {
            userId,
            parentId,
            fileId,
            groupId
        } = this.props;

        if (prevProps.fileId !== fileId || prevProps.groupId !== groupId) {
            this.close();
        }

        if (!prevState.text && this.state.text) {
            if (parentId) {
                sendMixPanelEvent({
                    eventName: START_NEW_REPLY,
                    eventData: {
                        'Is Collaborator': !userId,
                        'Comment ID': parentId
                    }
                });
            } else {
                sendMixPanelEvent({
                    eventName: START_NEW_COMMENT,
                    eventData: {
                        'Is Collaborator': !userId,
                        'Comment Source': 'Comment Box'
                    }
                });
            }
        }
    }

    open(annotationObj = null) {
        const {
            setShowNoCommentsFalse,
            onFocus,
            setCurrentCommentId,
            commentBoxOpened
        } = this.props;

        commentBoxOpened();

        if (annotationObj) {
            this.setState({
                tempAnnotations: [annotationObj]
            });
        }
        setShowNoCommentsFalse && setShowNoCommentsFalse();
        onFocus && onFocus();

        this.textarea && this.textarea.focus();

        this.setState({
            isOpen: true
        });

        setCurrentCommentId(undefined);
    }

    close(e) {
        const {
            setShowNoCommentsTrue,
            parentId,
            setReplyClicked,
            stopEdit,
            commentBoxCancelled
        } = this.props;

        e && e.stopPropagation();

        setShowNoCommentsTrue();

        commentBoxCancelled({
            parentId,
            text: this.state.text
        });

        if (parentId) { setReplyClicked(); }
        if (stopEdit) { stopEdit(); }

        this.setState({
            isOpen: false,
            require: false
        });

        this.setState({
            text: ''
        });
    }

    textareaChange(event) {
        const value = get(event, 'target.value');

        this.setState({
            require: false,
            text: value
        });
    }

    onBoxClick(e) {
        e.detail = COMMENT_BOX_EVENT_NAME;
    }

    isNotValid() {
        return !this.state.text.trim();
    }

    save() {
        const {
            stopEdit,
            setShowNoCommentsFalse,
            parentId,
            setReplyClicked
        } = this.props;

        if (this.isNotValid()) {
            this.setState({
                require: true
            });

            this.textarea.focus();
            return;
        }

        if (stopEdit) {
            stopEdit(this.state.text);
        }

        if (parentId) {
            this.saveReply();
            setReplyClicked();
        }

        if (!parentId && !stopEdit) {
            this.saveComment();
        }

        this.setState({
            isOpen: false,
            text: ''
        });

        setShowNoCommentsFalse();
    }

    saveComment() {
        const {
            timecode,
            groupId,
            fileId,
            setCurrentCommentId,
            collaboratorId,
            addComment,
            annotations,
            userId
        } = this.props;

        let timecodeNew = timecode;

        if (!this.showTimeCode()) {
            timecodeNew = null;
        }

        const id = uuid();

        const payload = {
            body: this.state.text,
            timecode: timecodeNew,
            groupId,
            fileId,
            id,
            collaboratorId,
            annotations,
            pending: true
        };

        if (!this.state.checkBox) {
            payload.timecode = null;
        }

        addComment(payload);
        setCurrentCommentId(id);

        reportToBigQuery({
            group: 'collaboration',
            type: 'add_comment_in_collaboration_conversation',
            reason: 'comment'
        });

        sendMixPanelEvent({
            eventName: SAVE_NEW_COMMENT,
            eventData: {
                'Timestamp': payload.timecode,
                'Text Lenght': payload.body.length,
                'Has Annotation': !!annotations.length,
                'Is Collaborator': !userId
            }
        });
    }

    saveReply() {
        const {
            parentId,
            groupId,
            fileId,
            setCurrentCommentId,
            collaboratorId,
            userId,
            addComment
        } = this.props;

        const payload = {
            body: this.state.text,
            parentId,
            groupId,
            fileId,
            id: uuid(),
            collaboratorId,
            pending: true
        };

        addComment(payload);
        setCurrentCommentId(parentId);

        reportToBigQuery({
            group: 'collaboration',
            type: 'add_comment_in_collaboration_conversation',
            reason: 'reply'
        });

        sendMixPanelEvent({
            eventName: SAVE_NEW_REPLY,
            eventData: {
                'Comment ID': parentId,
                'Is Collaborator': !userId
            }
        });
    }

    showTimeCode() {
        const {
            filerr,
            parentId,
            stopEdit
        } = this.props;

        if (parentId) {return false;}
        if (stopEdit) {return false;}

        if (filerr.previewType === VIDEO_TYPE || filerr.previewType === AUDIO_TYPE) {
            return true;
        }
        return false;
    }

    onChange(e) {
        this.setState({
            checkBox: e.target.checked
        });

        sendMixPanelEvent({
            eventName: CLICKED_TIMESTAMP_TOGGLE,
            eventData: {
                'State': !this.state.checkBox,
                'File Type': this.props.filerr.previewType,
                'Duration': this.props.filerr.duration
            }
        });
    }

    render() {
        const {
            username,
            userImage,
            timecode,
            body,
            timecodeEdit,
            isReply,
            email,
            disabled,
            i18n
        } = this.props;

        const {
            isOpen,
            require,
            text
        } = this.state;

        const classes = classNames('comment-box-wrapper', {
            open: isOpen,
            require,
            reply: isReply,
            'edit-reply': body,
            disabled
        });

        const topLevelClasses = classNames('comment-box', {
            reply: isReply,
            'edit-reply': body
        });

        const collaboratorName = username || email || '';

        const timeStamp = timecodeEdit ? secToTimestamp(timecodeEdit) : secToTimestamp(timecode);

        return (
            <div onClick={this.onCommentBoxClick} className={topLevelClasses}>
                <div className={classes} onClick={this.onBoxClick}>
                    <div className="text">
                        <Avatar username={collaboratorName} src={userImage} className="avatar"/>
                        <textarea id="collaboration-comment-box"
                            value={text}
                            placeholder={i18n.t('attachments_preview.collaboration.comments.add_a_comment')}
                            onFocus={this.open}
                            onChange={this.textareaChange}
                            ref={(ref) => this.textarea = ref}/>
                    </div>
                    <footer >
                        <span className="save-actions">
                            <button className="btn-cancel" onClick={this.close}>{i18n.t('attachments_preview.collaboration.comments.cancel')}</button>
                            <button className="btn-add" onClick={this.save}>{i18n.t('attachments_preview.collaboration.comments.add')}</button>
                        </span>
                        {this.showTimeCode() && <div className="timestamp">
                            <Checkbox defaultChecked onChange={this.onChange}/>
                            <span className="time">{i18n.t('attachments_preview.collaboration.comments.time_stamp')} ({timeStamp})</span>
                        </div>}
                    </footer>
                </div>
            </div>
        );
    }
}

CommentBox.propTypes = {
    userId: PropTypes.number,
    username: PropTypes.string,
    userImage: PropTypes.string,
    timecode: PropTypes.number,
    defaultOpen: PropTypes.bool,
    parentId: PropTypes.string,
    groupId: PropTypes.string,
    fileId: PropTypes.string,
    setShowNoCommentsFalse: PropTypes.func,
    setShowNoCommentsTrue: PropTypes.func,
    setReplyClicked: PropTypes.func,
    commentBoxCancelled: PropTypes.func.isRequired,
    onFocus: PropTypes.func,
    filerr: FilerrShape,
    body: PropTypes.string,
    timecodeEdit: PropTypes.number,
    stopEdit: PropTypes.func,
    isReply: PropTypes.bool,
    disabled: PropTypes.bool,
    email: PropTypes.string,
    collaboratorId: PropTypes.string,
    addComment: PropTypes.func,
    annotations: PropTypes.array,
    setCurrentCommentId: PropTypes.func,
    i18n: PropTypes.shape({
        t: PropTypes.func
    }),
    commentBoxOpened: PropTypes.func.isRequired
};

CommentBox.defaultProps = {
    userImage: '',
    defaultOpen: false,
    parentId: '',
    groupId: '',
    fileId: '',
    setShowNoCommentsFalse: () => null,
    setShowNoCommentsTrue: () => null,
    addComment: () => null,
    annotations: []
};

const mapStateToProps = (state) => {
    const { username, userImage, email, id: collaboratorId, userId } = CollaboratorsSelectors.getCurrentCollaborator(state);
    const isSubmittingReviews = LoadingsSelectors.isCreateCommentsLoading(state);
    const collaborationStatus = FilesSelectors.getCurrentFileStatus(state);

    return {
        username,
        email,
        userImage,
        groupId: CurrentsSelectors.getCurrentGroupId(state),
        fileId: CurrentsSelectors.getCurrentFileId(state),
        filerr: FilerrsSelectors.getCurrentFilerr(state),
        userId,
        collaboratorId,
        timecode: CurrentsSelectors.getCurrentTimecode(state),
        disabled: isSubmittingReviews || collaborationStatus !== COLLABORATION_ACTIVE_STATUS,
        annotations: getTempAnnotations(state)
    };
};

export default compose(
    Translations.connect,
    connect(mapStateToProps, {
        commentBoxCancelled,
        commentBoxOpened,
        onFocus: emitCommentBoxGotFocus,
        addComment: CommentsActions.addComment,
        setCurrentCommentId: CurrentsActions.setCurrentCommentId
    }))(CommentBox);
